import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SetupAttentionService } from '../../services/setup/setup-attention.service';

@Component({
  selector: 'app-setup-attention-modal',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './setup-attention-modal.component.html',
  styleUrl: './setup-attention-modal.component.scss',
})
export class SetupAttentionModalComponent {
  @Input() visible = false;
  @Output() closeModal = new EventEmitter<void>();

  readonly setupAttentionService = inject(SetupAttentionService);
  private readonly router = inject(Router);

  close(): void {
    this.closeModal.emit();
  }

  goTo(route: string): void {
    this.close();
    this.router.navigateByUrl(route);
  }
}
